import { Box } from '@/shared/ui';
import { CustomTypography } from '@/shared/ui/Typography';

import {
  ComingSoonOverlay,
  IconContainer,
  StyledChannelCardBox,
} from './styles';

interface ChannelCardProps {
  icon: React.ReactNode;
  label: string;
  caption?: string;
  onClick?: () => void;
  variant?: 'primary' | 'secondary';
  disabled?: boolean;
}

export const ChannelCard = ({
  icon,
  label,
  variant = 'primary',
  caption,
  disabled,
  onClick,
  ...otherProps
}: ChannelCardProps) => {
  const handleClick = () => {
    if (!disabled && onClick) {
      onClick();
    }
  };

  return (
    <Box sx={{ position: 'relative', width: '100%' }}>
      <StyledChannelCardBox
        variant={variant}
        disabled={disabled}
        onClick={handleClick}
        {...otherProps}
      >
        <IconContainer variant={variant}>{icon}</IconContainer>
        <CustomTypography
          variant="subtitle2"
          align={variant === 'primary' ? 'center' : 'left'}
          fontWeight={variant === 'primary' ? '500' : '600'}
        >
          {label}
        </CustomTypography>
        {caption ? (
          <CustomTypography
            variant="caption"
            align={variant === 'primary' ? 'center' : 'left'}
          >
            {caption}
          </CustomTypography>
        ) : null}
      </StyledChannelCardBox>
      <ComingSoonOverlay disabled={disabled}>Coming Soon</ComingSoonOverlay>
    </Box>
  );
};
